import { PaletteColor } from '@mui/material/styles'

export type ThemeColours =
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning'
  | 'red'
  | 'green'
  | 'grey'
  | 'blue'
  | 'orange'
  | 'yellow'
  | 'black'
  | 'white'
  | 'pink'
  | 'neutral'

const primaryMain = '#0B2948'
const neutralMain = '#FBFBFB'
const secondaryMain = '#0074D3'

export const primary: PaletteColor = {
  main: primaryMain,
  light: '#6F98CB',
  dark: '#0C355C',
  contrastText: neutralMain,
  '100': '#E0E9F0',
  '200': '#D1DEE8',
  '300': '#A3BEDB',
  '400': '#6F98CB',
  '500': '#3F77BB',
  '600': '#1A5595',
  '700': '#0F4277',
  '800': '#0C355C',
  '900': '#0B2948',
}

export const blue: PaletteColor = {
  light: '#1394F6',
  main: '#006FFF',
  dark: '#0667B1',
  contrastText: '#FBFBFB',
  '100': '#75C0FA',
  '200': '#4EAFF9',
  '300': '#269DF7',
  '700': '#05508A',
  '800': '#044576',
  '900': '#032E4F',
}

export const neutral: PaletteColor = {
  main: neutralMain,
  light: '#EBEBEB',
  dark: '#D6D6D6',
  contrastText: primaryMain,
  '400': '#C2C2C2',
  '500': '#ADADAD',
  '600': '#858585',
  '700': '#707070',
  '800': '#5C5C5C',
  '900': '#DDE0E3',
}

export const secondary: PaletteColor = {
  main: secondaryMain,
  light: '#47A3FF',
  dark: '#005DAD',
  contrastText: '#FFFFFF',

  '100': '#F0F7FF',
  '200': '#D6EBFF',
  '300': '#ADD6FF',
  '400': '#7ABDFF',
  '500': '#47A3FF',
  '600': '#1A8FFF',
  '700': '#0074D3',
  '800': '#005DAD',
  '900': '#004687',
}

export const black: PaletteColor = {
  main: '#101010',
  light: '#3D3D3D',
  dark: '#0A0A0A',
  contrastText: neutralMain,
  '100': '#A3A3A3',
  '200': '#8F8F8F',
  '300': '#7A7A7A',
  '400': '#666666',
  '500': '#525252',
  '700': '#292929',
}

export const white: PaletteColor = {
  main: '#FBFBFB',
  light: '#EBEBEB',
  dark: '#D6D6D6',
  contrastText: primaryMain,
  '400': '#C2C2C2',
  '500': '#ADADAD',
  '600': '#858585',
  '700': '#707070',
  '800': '#5C5C5C',
  '900': '#474747',
}

export const red: PaletteColor = {
  main: '#DF2935',
  light: '#E44E58',
  dark: '#C31D28',
  contrastText: neutralMain,
  '100': '#F4B8BC',
  '200': '#EF959B',
  '300': '#EA7179',
  '700': '#A01821',
  '800': '#7C131A',
  '900': '#580E13',
}

export const pink: PaletteColor = {
  main: '#ff85a1',
  light: '#ff99ac',
  dark: '#ff5c8a',
  contrastText: neutralMain,
  '100': '#fae0e4',
  '200': '#f7cad0',
  '300': '#fbb1bd',
  '700': '#ff477e',
  '800': '#ff0a54',
  '900': '#CC003D',
}

export const orange: PaletteColor = {
  main: '#fc9403',
  light: '#ffc87c',
  dark: '#c26700ff',
  contrastText: white.main,
  '100': '#FFECD0',
  '200': '#F5BB8F',
  '300': '#F1A46A',
  '700': '#A85210',
  '800': '#833F0C',
  '900': '#5D2D09',
}

export const grey: PaletteColor = {
  main: '#808080',
  light: '#999999',
  dark: '#707070',
  contrastText: neutralMain,
  '100': '#D6D6D6',
  '200': '#C2C2C2',
  '300': '#ADADAD',
  '700': '#5C5C5C',
  '800': '#474747',
  '900': '#333333',
}

export const green: PaletteColor = {
  main: '#679436',
  light: '#7CB441',
  dark: '#53782B',
  contrastText: neutralMain,
  '100': '#B9D996',
  '200': '#A5CE78',
  '300': '#91C45A',
  '700': '#3E5A20',
  '800': '#293C15',
  '900': '#151E0B',
}

export const yellow: PaletteColor = {
  light: '#FFFDBF',
  main: '#FDE84A',
  dark: '#FDE321',
  contrastText: black.main,
  '100': '#FFF9D6',
  '200': '#FFF4AD',
  '300': '#FFEF85',
  '700': '#FDE10D',
  '800': '#F2D602',
  '900': '#DEC402',
}

export const uintel: PaletteColor = {
  main: '#0b2948',
  light: '#04497c',
  dark: '#061423',
  contrastText: white.main,
  '100': '#89c9fb',
  '200': '#62b8f9',
  '300': '#3aa6f8',
  '400': '#1394f6',
  '500': '#087ed9',
  '600': '#0667b2',
}

export const chartPalettes: { [key: string]: { [key: string]: string } } = {
  vulnerability: {
    low: yellow.main,
    moderate: orange.main,
    medium: orange.main,
    high: red.main,
    potential: pink.main,
    exposed: grey.main,
    unspecified: grey.light,
  },
}
